/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { ReactComponent as PreviewImage } from '../static/preview-text-image.svg';
import { ReactComponent as RightArrow } from '../static/pdf-arrow-circle-right.svg';
import { ReactComponent as LeftArrow } from '../static/pdf-arrow-circle-left.svg';

export const Pdfpreview = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  // eslint-disable-next-line no-shadow
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () =>
    setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);

  const goToNextPage = () =>
    setPageNumber(pageNumber + 1 >= numPages ? numPages : pageNumber + 1);

  const normalise = ((pageNumber - 1) * 100) / (numPages - 1);
  const pdfURL = localStorage.getItem('final')
    ? localStorage.getItem('final')
    : '';

  return (
    <div className="pdf-generate-preview">
      <div className="preview-text-image">
        <PreviewImage />
      </div>
      <div className="twitter-pdf-generator">
        {pdfURL ? (
          <>
            <div className="pdf-pages-full">
              <p>Story - {numPages} Pages</p>
            </div>
            <div className="pdf-zoomer-image">
              <div className="d-flex align-items-center">
                <div className="pdf-pages-number">
                  {pageNumber}/{numPages}
                </div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${normalise}%` }}
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
              </div>
            </div>

            <nav>
              {pageNumber === numPages ? (
                <button className="left-page" onClick={goToPrevPage}>
                  <LeftArrow />
                </button>
              ) : (
                <button className="right-page" onClick={goToNextPage}>
                  <RightArrow />
                </button>
              )}
              {pageNumber === 1 ? (
                <button className="right-page" onClick={goToNextPage}>
                  <RightArrow />
                </button>
              ) : (
                <button className="left-page" onClick={goToPrevPage}>
                  <LeftArrow />
                </button>
              )}
            </nav>

            <Document
              file="https://twitterthread.s3.amazonaws.com/threadPDF/JAYKHATRI2910-1547479368603418625_Twitter-Thread_0101_to_0101.pdf"
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={error => {
                console.log('load-error');
                console.log(error);
              }}
              onSourceError={error => {
                console.log('load-onSourceError');
                console.log(error);
              }}
            >
              <Page pageNumber={pageNumber} />
            </Document>
          </>
        ) : (
          <>
            <div className="react-pdf__Document">
              <Box sx={{ display: 'flex' }}>
                <CircularProgress />
              </Box>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// export class Pdfpreview3 extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       finalpageNumber: null,
//     };
//   }

//   onDocumentLoadSuccess = numbers => {
//     this.setState({ finalpageNumber: numbers });
//   };

//   render() {
//     return (
//       <div className="pdf-generate-preview">
//         <div className="twitter-pdf-generator">
//           <Document
//             file="https://twitterthread.s3.amazonaws.com/threadPDF/JAYKHATRI2910-1552548657962307584_Twitter-Thread_0101_to_0101.pdf"
//             onLoadSuccess={this.onDocumentLoadSuccess}
//           >
//             <Page pageNumber={this.state.finalpageNumber} />
//           </Document>
//         </div>
//       </div>
//     );
//   }
// }
